// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c8p3t","placeholdersHeader":"styles_placeholdersHeader__1LmC1","editorStyle":"styles_editorStyle__18c5u","placeholdersBox":"styles_placeholdersBox__2xm0q"};